import React, { useEffect } from "react";
import Input from "../../../../../core/Inputs/DefaultInput";
import SurveyListHeader from "../../../../../component/common/layout/SurveyListHeader";
import SurveyListSidebar from "../../../../../component/common/layout/SurveyListSidebar";
import SubHeader from "../../../../../component/common/layout/SubHeader";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useVerifySurveyId } from "../../../../../hooks";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { apiRequest } from "../../../../../services/apiService";
import Radio from "../../../../../core/Radio";
import Switch from "../../../../../core/Switch";
import { useTranslation } from "react-i18next";
export default function ThankYouPages() {
  const { survey_name } = useSelector((state) => state.permissionsData);
  const survey_id = useVerifySurveyId();
  const [graphChart, setGraphChart] = React.useState(false);
  const [graphChartType, setGraphChartType] = React.useState("spider");
  const [description, setDescription] = React.useState("");
  const [heading, setHeading] = React.useState("");
  const [buttonView, setButtonView] = React.useState("");
  const [buttonDownload, setButtonDownload] = React.useState("");
  const { t, i18n } = useTranslation();

  // Function to handle graph require changes
  const handleRequiredChange = (e) => {
    console.log(e.target.checked);
    setGraphChart(e.target.checked);
  };
  // Function to handle textarea changes
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value); // Update the state with the new value
  };

  // Function to handle textarea changes
  const handleHeadingChange = (e) => {
    setHeading(e.target.value); // Update the state with the new value
  };
  const save = () => {
    const payload = {
      su_survey_id: survey_id,
      thankyou_heading: heading,
      thankyou_description: description,
      thankyou_view_button: buttonView,
      thankyou_download_button: buttonDownload,
    };
    console.log("++===++payload--", payload);
    postData(payload);
  };

  const postData = async function (payload) {
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/survey/updateThankYouPageSetting`,
      data: payload,
      showErrorToast: false,
    });
    if (response) {
      console.log(response);
      if (response.data.statusCode == 200) {
        localStorage.setItem("token_id", response.data.token);
        toast.success(response.data.msg);
      } else {
        localStorage.setItem("token_id", response.data.token);
        toast.error(response.data.msg);
      }
    } else if (error) {
      toast.error(error);
    }
  };

  const getThankyouSetting = async () => {
    let payload = {
      su_survey_id: survey_id,
    };
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/survey/getThankyouSetting`,
      data: payload,
      showErrorToast: false,
    });
    if (response) {
      console.log(response);
      if (response.data.statusCode == 200) {
        setDescription(response.data.data[0].thankyou_description);
        setHeading(response.data.data[0].thankyou_heading);
        setButtonDownload(response.data.data[0].thankyou_download_button);
        setButtonView(response.data.data[0].thankyou_view_button);
        localStorage.setItem("token_id", response.data.token);
      } else {
        localStorage.setItem("token_id", response.data.token);
        toast.error("Something went wrong, please try again.");
      }
    } else if (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    if (survey_id) {
      getThankyouSetting();
    }
  }, [survey_id]);

  return (
    <div
      id="content"
      className="flex-grow-1 dashboard-page-outer d-flex flex-column bg-white"
    >
      {/* <SubHeader /> */}
        <div className="survey-main-container">
          <div className="page-heading">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/survey/list">{t("survey.title")}</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <strong>{t('settings.thankyouPage.title')}</strong>
                </li>
              </ol>
            </nav>
             <h1>{t('settings.thankyouPage.title')}</h1>
             </div>
            <div className="survey-container">
              <div className="page-content-wrap variables-main-container p-0">
                <div className="main-sec-wrap">
                  <div className="pagesRow varPg">
                    <div className="row gx-12px">
                      <div className="col-lg-12 position-relative">
                        <div className="form-group mb-3">
                          <label className="form-label-custom">
                            {t("settings.questionnaire.pageHeading")}{" "}
                          </label>
                          <textarea
                            className="form-control"
                            placeholder={t(
                              "settings.questionnaire.pageHeading"
                            )}
                            rows={5}
                            value={heading}
                            onChange={window.modulePermissions.M22.edit == 1 ? handleHeadingChange : undefined}
                            readOnly={window.modulePermissions.M22.edit != 1}
                          />
                        </div>
                        <div className="row gx-12px">
                          <div className="col-lg-12 position-relative">
                            <div className="form-group mb-3">
                              <label className="form-label-custom">
                                {t("settings.thankyouPage.pageDescription")}{" "}
                              </label>
                              <textarea
                                className="form-control"
                                placeholder={t(
                                  "settings.thankyouPage.pageDescription"
                                )}
                                rows={5}
                                value={description}
                                onChange={window.modulePermissions.M22.edit == 1 ? handleDescriptionChange : undefined}
                                readOnly={window.modulePermissions.M22.edit != 1}
                              />
                            </div>
                          </div>

                          <div className="row gx-12px">
                            <div className="col-lg-12 position-relative">
                              <div className="form-group mb-12px">
                                <label className="form-label-custom">
                                  {t("settings.thankyouPage.buttonText1")}
                                </label>
                                <input
                                  className="form-control"
                                  placeholder={t(
                                    "settings.thankyouPage.buttonText1"
                                  )}
                                  rows={5}
                                  defaultValue={""}
                                  value={buttonView}
                                  onChange={window.modulePermissions.M22.edit == 1 ? (e) => setButtonView(e.target.value) : undefined}
                                  readOnly={window.modulePermissions.M22.edit != 1}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row gx-12px">
                            <div className="col-lg-12 position-relative">
                              <div className="form-group mb-12px">
                                <label className="form-label-custom">
                                  {t("settings.thankyouPage.buttonText2")}{" "}
                                </label>
                                <input
                                  className="form-control"
                                  placeholder={t(
                                    "settings.thankyouPage.buttonText2"
                                  )}
                                  rows={5}
                                  defaultValue={""}
                                  value={buttonDownload}
                                  onChange={window.modulePermissions.M22.edit == 1 ? (e) => setButtonDownload(e.target.value) : undefined}
                                  readOnly={window.modulePermissions.M22.edit != 1}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group mb-3">
                          <div className="button-wrap pt-2">
                            {window.modulePermissions.M22.edit == 1 && (<button
                              className="btn btn-primary next-btn"
                              type="button"
                              onClick={() => save()}
                            >
                              {t("settings.questionnaire.save")}
                            </button>)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  );
}
